import { AbstractDialogContent } from '@abstracts/dialog/dialog-content';
import { Component, Injector, Input, Output, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ChargingStationsService } from '@services/entity/charging-stations.service';
import { ToastService } from '@services/toast/toast.service';
import { NgxSpinnerService } from 'ngx-spinner';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-delete-charging-station-dialog-content',
  templateUrl: './delete-charging-station-dialog-content.component.html',
  styleUrls: ['./delete-charging-station-dialog-content.component.scss']
})
export class DeleteChargingStationDialogContentComponent extends AbstractDialogContent implements OnInit {

  public className = 'DeleteChargingStationDialogContentComponent';

  @Input() private chargingStationId: string;

  @Input() public deleted: boolean;

  constructor(
    public activeModal: NgbActiveModal,
    private chargingStationsService: ChargingStationsService,
    private toastService: ToastService,
    private spinner: NgxSpinnerService,
    injector: Injector) {
    super(activeModal, injector);
  }

  ngOnInit(): void {   
    super.ngOnInit();
  }

  onConfirmClick() {
    this.spinner.show()
    this.chargingStationsService.deleteEntity(this.chargingStationId).subscribe(result => {
      this.toastService.success($localize`:@@DeletedDialogSuccessHeader:Ladestation erfolgreich gelöscht.`);
      this.spinner.hide()
      this.activeModal.close();
      this.deleted = true;
      
    }, error => {
      this.spinner.hide()
      this.toastService.error($localize`:@@DeletedDialogErrorHeader:Ladestation konnte nicht gelöscht werden.`);
      console.error(error)
      this.deleted = false;
    });
  }

  onCancelClick() {
    this.activeModal.close();
    this.deleted = false;
  }

  openSuccessDialog() {
    Swal.fire({
      title: $localize`:@@DeletedDialogSuccessHeader:Gelöscht!`,
      text: $localize`:@@DeletedDialogSuccessText:Die Ladestation wurde gelöscht.`,
      icon: 'success',
      confirmButtonText: $localize`:@@DialogOkButton:OK`,
      confirmButtonColor: 'green'
    }).then((result) => {
      this.activeModal.close();
    });
  }
}
